module.exports = "https://cdn.realtymogul.com/static/media/funds_retire_bg.7c4694e9.jpg";